export const suggestionsInputSelector = '.js-project_search_suggestions_input';
const suggestionsSelector = '.js-project_search_suggestions';
const suggestionsCssClass = 'project_search__suggestions';
export const clearSuggestions = () => {
    const suggestions = document.querySelector(suggestionsSelector);
    if (suggestions) {
        suggestions.innerHTML = '';
        suggestions.classList.remove(suggestionsCssClass);
    }
};
window.up.compiler(suggestionsInputSelector, (input) => {
    const minSearchLength = JSON.parse(input.dataset.minSearchLength || '0');
    const watchOptions = { delay: 300 };
    window.up.watch(input, watchOptions, (value) => {
        if (value.trim().length >= minSearchLength) {
            const renderOptions = {
                url: input.dataset.suggestionsAction,
                method: 'post',
                params: { q: value.trim() },
                headers: { 'x-csrf-token': input.dataset.csrfToken },
                layer: window.up.layer.current,
                failTarget: suggestionsSelector
            };
            window.up.render(suggestionsSelector, renderOptions);
        }
        else {
            clearSuggestions();
        }
    });
});
